import React from 'react'

const Charging = () => {
  return (
    <div className="flex justify-center items-center h-screen">
        <div className="w-12 h-12 border-4 border-dashed rounded-full animate-spin border-black"></div>
    </div>
  )
}

export default Charging